<template>
  <div class="">
    {{ infoText }}
  </div>
</template>
<script>
// //引入jwt
// import jwt from "jsonwebtoken";
// let jwt=require("jsonwebtoken");

export default {
  components: {},
  data() {
    return {
      infoText: "缺少必要参数",
      username: "", //用户名
      password: "", //密码
      userid: Number,
      loading: false,
      customLogoUrl: "", //定制logo
      downloadUrl: this.url.downloadUrl, //查看成果公共链接
      isStandardVersion: true, //是否未标准版
    };
  },
  created() {
    //若网址中携带code参数则去获取定制logo
    if (this.$route.query.token) {
      this.loginFun();
    }
    //防止登录之后通过网址栏中的箭头返回到登录页 要清空loacalStorage中的数据！！！
    let theme = window.localStorage.getItem("theme");
    let fontSize = window.localStorage.getItem("fontSize");

    //避免切换主题之后再登录，主题选中紊乱
    window.localStorage.setItem("theme", theme);
    window.localStorage.setItem("fontSize", fontSize);
    this.Cookies.remove("c_m_LinID");
  },
  methods: {
    //登录功能
    loginFun() {
      this.username = this.$route.query.token;
      this.password = "fj.5722902";

      //公钥
      let publicKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCmbinpI6ZKti6bqma+vv05q4Q+uBgGxHxD5tPUnZBoWNk5r3gUEJwz8khgNUvndD/Tz9bRnjBigjJYDbtGpNDypde1NM4qCp3BmLUQVD5KUnyLvN4HN/FI6W2o8DpXnMSY9829+CNXCV4z5Y9epe6ufkUJlXRhGp01bTxI3mLL/wIDAQAB";
      let um = this.$getEncrypt(publicKey, this.username);
      let psd = this.$getEncrypt(publicKey, this.password);

      console.log(um);
      console.log(psd);

      this.loading = true;
      this.axios({
        method: "post",
        url: "/japi/user/yunnan/login/",
        data: {
          username: um,
          //password: psd,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
          console.log("登录成功======");
          console.log(res);
          //判断浏览器是否支持 localStorage 这个属性
          if (!window.localStorage) {
            alert("您的浏览器不支持localstorage");
            return false;
          } else {
            // 将用户名存储到window.localStorage
            window.localStorage.setItem("username", res.data.data.userName);
            window.localStorage.setItem("token", res.data.data.userToken);
            console.log(res.data.data.userName);
            console.log(res.data.data.userToken);

            this.dialogVisibleLogin = false; //弹窗消失
            this.isLogin = true; //登录 个人中心显示

            this.setCnkiCookie(res.data.data);

            this.getCheckFun(); //是否有立法知识库的权限
          }
        } else {
          this.loading = false;
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    setCnkiCookie(obj) {
      //实现统一登录的cookie设置
      if (obj.LID) {
        let c_m_LinID =
          "LinID=" +
          obj.LID +
          "&ot=" +
          encodeURIComponent(dateformat(new Date(), "MM/dd/yyyy hh:mm:ss"));
        setParentCookie("c_m_LinID", c_m_LinID);
        setParentCookie("Ecp_LoginStuts", JSON.stringify(obj.userinfo));
        //获取clientID
        setParentCookie("Ecp_ClientId", obj.Ecp_ClientId);
        setParentCookie("LID", obj.LID);
      }
    },
    clearCnkiCookie() {},
    //是否有立法知识库的权限
    getCheckFun() {
      this.axios({
        method: "get",
        url: "/japi/user/is_has_permission/",
        params: {
          perm_codename_list: JSON.stringify(["can_check_files"]),
        },
      }).then((res) => {
        console.log("权限返回======");
        console.log(res);
        if (res.data.code == 200 || res.data.code == 403) {
          console.log("权限返回成功======");
          //判断浏览器是否支持 localStorage 这个属性
          if (!window.localStorage) {
            alert("您的浏览器不支持localstorage");
            return false;
          } else {
            this.can_check_files = res.data.data[0].can_check_files;
            //存储到window.localStorage
            window.localStorage.setItem(
              "can_check_files",
              res.data.data[0].can_check_files
            );

            if (this.$route.query.pagetype == 1) {
              this.$router.push({
                path: "/recordReview/reviewTaskManage",
                query: {
                  ...this.$route.query,
                  token: undefined,
                  pagetype: undefined,
                },
              });
            } else {
              this.$router.push("/index");
            }
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.login-footer {
  .footer-p,
  .footer-p .link a,
  .footer-p .msg a,
  .footer-p .copyright ul li span {
    color: #4165ed;
  }
}
</style>
<style lang="scss" scoped>
@import "~@/assets/css/mixin.scss"; //定义方法
.el-footer {
  height: auto !important;
  // @include theme();
  color: #4165ed;
  background: #fff;
}
.widthM {
  width: calc(66vw);
  min-width: 1000px;
}
.login-wrap {
  position: relative;
  overflow: inherit;
  // background:url("../assets/images/login_bg.png") left 0 no-repeat;
  // width: 1100px;
  margin: 0 auto;
  & > img {
    width: 36vw;
    min-width: 480px;
  }
}
.login-box-wrap {
  .login-box {
    padding-bottom: 115px;
    min-width: 1200px;
    margin: 0 auto;
    //height:calc(100vh - 115px);
  }
  // .footer-i{
  //   // width: calc(66vw);
  //   // min-width:1000px;
  //   .footer-p{
  //     width: calc(66vw);
  //     min-width:1000px;
  //   }
  // }
}
.footer-wrap-i-login {
  height: 115px;
  background: #fff;
}
.login-box-wrap {
  background: #4165ed;
  // background-size:90%;
  // background-attachment: fixed;
  // filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../assets/images/login_bg.jpg', sizingMethod='scale');
  // -ms-filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../assets/images/login_bg.jpg', sizingMethod='scale');
  // background-size: cover;
  // -moz-background-size: cover;
  // -webkit-background-size: cover;
}
.login-box {
  .logo {
    margin-right: 1.4vw;
    margin-bottom: 2vw;
  }
  .title1 {
    margin-top: 5px;
    margin-bottom: 2vw;
  }
  .customLogo {
    img {
      display: block;
    }
    margin-bottom: 2vw;
  }
  .txt {
    font-size: 30px;
    color: #fff;
    padding-top: calc(5vh);
    padding-bottom: calc(2.9vh);
    left: 0;
    right: 0;
    // width: 1100px;
    margin: auto;
    .logo {
      width: 165px;
      height: 56px;
      background: url("../assets/images/logo.png") 0 0 no-repeat;
    }
    .title1 {
      width: 489px;
      height: 49px;
      background: url("../assets/images/title1.png") 0 0 no-repeat;
    }
    .title2 {
      width: 678px;
      height: 29px;
      background: url("../assets/images/title2.png") 0 0 no-repeat;
    }
  }
  .login-r /deep/ {
    margin-top: 2vh;
    // width: 456px;
    width: 21vw;
    min-width: 320px;
    background: #ffffff;
    // height: 432px;
    padding: 6vh 2.2vw;
    box-shadow: 0px 30px 28px 4px rgba(8, 2, 3, 0.17);
    border-radius: 20px;
    // margin-top: 11%;
    position: relative;
    box-sizing: border-box;
    z-index: 2;
    .login-r-con {
      width: 100%;
      height: auto;
      position: relative;
      margin: 0 auto;
      .login-r-con-inner {
        width: auto !important;
        margin: 0 auto;
      }
      .freelogin {
        text-align: right;
        color: #2f6691;
        font-size: 12px;
        margin-top: 30px;
        cursor: pointer;
        width: 80%;
        margin: 0 auto;
        line-height: 22px;
      }
      a.loginBtn {
        text-align: center;
        margin-top: 10px;
        line-height: 42px;
        font-size: 18px;
        color: #fff;
        display: block;
        margin: 0 auto;
        width: calc(100% - 16px);
        height: 42px;
        font-weight: 400;
        background: #4165ed;
        border: 1px solid #4165ed;
        box-shadow: 0px 14px 15px 1px rgba(18, 105, 255, 0.25);
        border-radius: 6px;
        .el-loading-mask {
          background-color: rgba(255, 255, 255, 0.2);
        }
        .el-loading-spinner {
          width: 40px;
          height: 42px;
          left: 25%;
          margin-top: -16px;
          .circular {
            height: 30px;
            width: 30px;
          }
          .path {
            stroke: #fff;
          }
        }
      }
      .title {
        font-size: 26px;
        text-align: center;
        color: #4165ed;
        padding-top: 0;
        letter-spacing: 1px;
        // padding-bottom: 50px;
        padding-bottom: 2vw;
        font-weight: 400;
        line-height: 1;
        letter-spacing: 6px;
      }
      .tips_box {
        padding-left: 10px;
        font-size: 12px;
        color: #f70;
        width: 290px;
        margin: 0px auto 10px;
        line-height: 24px;
        background: #fdf6ec;
        border: 1px solid #f70;
      }
      .login_inputbox {
        padding-left: 16px;
        margin: 0 auto;
        line-height: 40px;
        background: transparent;
        width: calc(100% - 16px);
        height: 40px;
        font-size: 16px;
        border: 1px solid #4165ed;
        border-radius: 6px;
        img {
          margin-top: 6px;
        }
        i {
          font-size: 20px;
          color: #15538e;
        }
      }
      .mb29 {
        margin-bottom: 1.5vw;
      }
      .forget {
        font-weight: 400;
        color: #2b3449;
        font-size: 14px;
        opacity: 0.6;
        padding: 0.8vw 0 1.4vw;
        a:hover {
          color: #ff3300;
        }
      }
      .login_input {
        height: 40px;
        width: 86%;
        font-size: 15px;
        line-height: 40px;
        border: none;
        padding-left: 12px;
        outline: none;
        color: #333;
        background: transparent;
        .el-input__inner {
          border: none;
          padding-left: 0;
          background-color: transparent;
        }
      }
      input::-webkit-input-placeholder {
        color: #7a7a7a;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #7a7a7a;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #7a7a7a;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #7a7a7a;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .login-box {
    .txt {
      .logo {
        width: 154px;
        height: 51px;
        background: url("../assets/images/logo-m.png") 0 0 no-repeat;
      }
      .title1 {
        width: 447px;
        height: 44px;
        background: url("../assets/images/title1-m.png") 0 0 no-repeat;
      }
      .title2 {
        width: 619px;
        height: 26px;
        background: url("../assets/images/title2-m.png") 0 0 no-repeat;
      }
    }
  }
  .widthM {
    width: calc(66vw);
    min-width: 940px;
  }
  .footer-i {
    width: 1080px;
    min-width: 1080px;
    .footer-p .footer-logo {
      margin-right: 30px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .login-box {
    .txt {
      .logo {
        width: 141px;
        height: 47px;
        background: url("../assets/images/logo-s.png") 0 0 no-repeat;
      }
      .title1 {
        width: 410px;
        height: 41px;
        background: url("../assets/images/title1-s.png") 0 0 no-repeat;
      }
      .title2 {
        width: 567px;
        height: 24px;
        background: url("../assets/images/title2-s.png") 0 0 no-repeat;
      }
    }
  }
  .widthM {
    width: calc(66vw);
    min-width: 940px;
  }
  .footer-i {
    width: 1080px;
    min-width: 1080px;
    .footer-p .footer-logo {
      margin-right: 30px;
    }
  }
}
</style>
